import {
  CUSTOMER_CLEAR,
  CUSTOMER_EDIT,
  CUSTOMER_LOAD,
  CUSTOMER_PASSWORD_CHANGE,
} from "./constants";

export const loadCustomer = (customer) => ({
  type: CUSTOMER_LOAD,
  payload: customer,
});

export const clearCustomer = () => ({
  type: CUSTOMER_CLEAR,
});

export const toggleEditModel = () => ({
  type: CUSTOMER_EDIT,
});

export const toggleChangePasswordModel = () => ({
  type: CUSTOMER_PASSWORD_CHANGE,
});
